var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("Webheader.configuration_list_" + _vm.typeSelected),
      },
    },
    [
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage overflow-hidden" },
          [
            _vm.tabName === 2 || _vm.tabName === 3 || _vm.tabName === 4
              ? _c("MessageList", {
                  attrs: {
                    tabName: _vm.tabName,
                    entitiesType: _vm.typeSelected,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }